// useVerifyOtpMutation.ts
import { useMutation } from '@tanstack/react-query';
import { verifyOtpApi } from '../auth/auth.api';
import { QUERY_KEYS } from '../querykeys';

export const useVerifyOtpMutation = () => {
  return useMutation({
    mutationKey: [QUERY_KEYS.VERIFY_OTP],
    mutationFn: verifyOtpApi,
  });
};